import Point from 'ol/geom/Point.js';
import toTurf from './toTurf.js';
import fromTurf from './fromTurf.js';
import GeoJSON from 'ol/format/GeoJSON.js';
import buffer from '@turf/buffer';
import circle from "@turf/circle";
import { getCoord } from "@turf/invariant";

export default function bufferInTurf(feat, projection, meter) {
    var formatgeo = new GeoJSON();
    var turfed = toTurf(feat, projection, formatgeo);
    var buffered = buffer(turfed, meter, { units: 'meters' });
    if (feat.getGeometry() instanceof Point) {
        buffered = circle(getCoord(turfed), meter, { units: 'meters' });
    }
    var buff = fromTurf(buffered, projection, formatgeo);
    return buff;
}
